import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_form = _resolveComponent("miezz-form")!

  return (_openBlock(), _createBlock(_component_miezz_form, {
    ref: "ruleForm",
    modelValue: _ctx.form,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form) = $event))
  }, {
    "form-item": _withCtx(({ item }) => [
      (item.Prop == 'ParamCountryId')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            prop: item.Prop,
            label: item.Label,
            rules: _ctx.form.Rules.ParamCountryId
          }, {
            default: _withCtx(() => [
              _createVNode(_component_miezz_select, {
                modelValue: _ctx.form.Data.ParamCountryId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.ParamCountryId) = $event)),
                onHandleChange: _ctx.onChangeParamCountryId,
                options: _ctx.countries,
                class: "form-item-select"
              }, null, 8, ["modelValue", "onHandleChange", "options"])
            ]),
            _: 2
          }, 1032, ["prop", "label", "rules"]))
        : _createCommentVNode("", true),
      (item.Prop == 'CountryCode')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "国家代码",
            prop: "CountryCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_miezz_input, {
                modelValue: _ctx.form.Data[item.Prop],
                "onUpdate:modelValue": ($event: any) => ((_ctx.form.Data[item.Prop]) = $event),
                placeholder: "请输入国家代码",
                onHandleBlur: _ctx.onBlurCountryCode,
                pattern: '[a-zA-Z]'
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true),
      (item.Prop == 'CompanyCode')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "企业代码类型",
            prop: "CompanyCode",
            rules: _ctx.form.Rules.CompanyCode
          }, {
            default: _withCtx(() => [
              _createVNode(_component_miezz_input, {
                modelValue: _ctx.form.Data[item.Prop],
                "onUpdate:modelValue": ($event: any) => ((_ctx.form.Data[item.Prop]) = $event),
                placeholder: "请输入企业代码类型",
                onHandleBlur: _ctx.onBlurCompanyCode,
                trim: false,
                pattern: '[a-zA-Z ]'
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
            ]),
            _: 2
          }, 1032, ["rules"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}